// extracted by mini-css-extract-plugin
module.exports = {"paper":"style_paper__30Ob2"};